
import common from './common/src';

const pluginObject = {
common
}

let plugins = []
for(let item of Object.keys(pluginObject)){
  plugins = plugins.concat(pluginObject[item]
  
)
}
  

  
export default plugins;
